import {GET_MANUAL_KYC_IMAGE, GET_MANUAL_KYC_REQ,GET_MANUAL_KYC_SUCCESS, GET_MANUAL_KYC_ERROR,GET_MANUAL_KYC_IMAGE_RESET } from "../actionType";

export const getManualKycImage = (image: any) => ({
    type: GET_MANUAL_KYC_IMAGE,
    payload: image
});

export const getManualKycReq = (value: any) => ({
    type: GET_MANUAL_KYC_REQ,
    payload: value
});

export const getManualKycReqSuccess = (data: any) => ({
    type: GET_MANUAL_KYC_SUCCESS,
    payload: data
});

export const getManualKycReqError = (error: any) => ({
    type: GET_MANUAL_KYC_ERROR,
    payload: error
});

export const getManualKycImageReset = () => ({
    type: GET_MANUAL_KYC_IMAGE_RESET,
});